import React, { useState } from "react";
import "./Header.scss";

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar p-right-2-lg p-right-2-xl">
      <div className="hidden-lg hidden-xl relative">
        <div className="navbar-container-mobile flex flex-justify-space-between">
          <div className="pokana-title flex flex-align-center">
            <i
              className="fa-solid fa-user-graduate"
            ></i>
          </div>
          <i
            className="sandwich-menu fa-solid fa-bars"
            onClick={() => setOpen(true)}
          ></i>
          {open && (
            <div
              className="sandwich-menu-content p-top-5 shadow-default"
              onClick={() => setOpen(false)}
            >
              <i
                className="sandwich-menu sandwich-menu-opened fa-solid fa-xmark"
                onClick={() => setOpen(false)}
              />
              <div>
                <a className="flex flex-align-center" href="#schedule">
                  <i className="fa-solid fa-clock m-right-1"></i>Програма
                </a>
              </div>
              <hr />
              <div>
                <a className="flex flex-align-center" href="#confirm">
                  <i className="fa-solid fa-calendar-check m-right-1"></i>
                  Потвърди
                </a>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-justify-space-between flex-justify-end-lg hidden-xs hidden-sm hidden-md">
        {/* <h5 className="text-primary m-left-2 m-top-0">Сватбена покана</h5> */}
        <ul className="navbar-container flex hidden-xs hidden-sm hidden-lg">
          <li>
            <a className="flex flex-align-center" href="#schedule">
            <i
            className="fa-solid fa-user-graduate"
            ></i>
            </a>
          </li>
        </ul>
        <ul className="navbar-container flex flex-justify-align-end hidden-xs">
          <li>
            <a className="flex flex-align-center" href="#schedule">
              <i className="fa-solid fa-clock m-right-1"></i>Програма
            </a>
          </li>
          <li>
            <a className="flex flex-align-center" href="#confirm">
              <i className="fa-solid fa-calendar-check m-right-1"></i>Потвърди
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;
